/**
 * This class is auto generated by using the
 * "Dots.KLASIS.TsGenerator".
 * */
export const common = {

    button: {
        open: `Atvērt`,
    },
    label: {
        errorCopySuccess: `Kļūdas paziņojums nokopēts uz starpglabātuvi`,
        linkCopySuccess: `Saite nokopēta uz starpliktuvi`,
        loadingData: `Notiek datu ielāde`,
        noClassifications: `Neatrada klasifikācijas`,
        noClassificationsDescription: `Pēc norādītajiem meklēšanas kritērijiem neizdevās atrast klasifikāciju`,
        search: `Meklēt`,
        validFrom: `Spēkā no`,
        validTo: `Spēkā līdz`,
    },
    tooltip: {
        copyPageLink: `Saites kopēšana`,
        copyRecordLink: `Kopēt saiti`,
        downloadFile: `Datnes lejupielāde`,
        openRecord: `Apraksts jaunā lapā`,
        printPage: `Drukāt lapu`,
        recordDesc: `Apraksts `,
    },
}
